<template>
  <div class="filterDiv">
    <div class="filterForm">
      <div>Select Role</div>
      <div style="margin-top: 10px; margin-bottom: 30px">
        <div class="row ml-0 mr-0">
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <div class="mr-2">
                <input
                  type="checkbox"
                  class="regular-checkbox"
                  v-model="isChecked.isInvestor"
                />
              </div>
              <div class="checkFieldCls">Investors</div>
            </div>
          </div>
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <div class="mr-2">
                <input
                  type="checkbox"
                  class="regular-checkbox"
                  v-model="isChecked.isFounder"
                />
              </div>
              <div class="checkFieldCls">Founder</div>
            </div>
          </div>
        </div>
        <!-- <div class="row ml-0 mr-0">
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <div class="mr-2">
                <input type="checkbox" class="regular-checkbox" v-model="isChecked.isFounder" />
              </div>
              <div class="checkFieldCls">Founder</div>
            </div>
          </div>
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <div class="mr-2">
                <input type="checkbox" class="regular-checkbox" v-model="isChecked.isTeam" />
              </div>
              <div class="checkFieldCls">Team</div>
            </div>
          </div>
        </div>-->
      </div>
      <div>
        <div style="font-size: 14px; margin-bottom: 10px">
          Search for a company
        </div>
        <multiselect
          v-model="companiesList"
          :options="portfolioAll"
          :multiple="true"
          track-by="_id"
          label="name"
          :custom-label="searchName"
          placeholder="Select Company"
        >
          <template slot="option" slot-scope="props">
            <div class="option__desc d-flex">
              <img
                class="optionCompanyImage"
                v-if="
                  (props.option.logo_url && props.option.logo_url.length > 0) ||
                  (props.option.image_id && props.option.image_id.length > 0)
                "
                :src="getImageUrl(props.option.logo_url)"
              />
              <div class="option__title">{{ props.option.name }}</div>
            </div>
          </template>
        </multiselect>
      </div>
      <div style="margin-top: 30px; margin-bottom: 30px">
        <div style="font-size: 14px; margin-bottom: 10px">Search for a Tag</div>
        <div>
          <b-form-tags
            input-id="tags-basic"
            v-model="tags"
            add-on-change
            separator=","
            placeholder="Enter Tags separated by comma"
            class="form-control team-form"
          ></b-form-tags>
        </div>
      </div>
    </div>
    <div class="filterFormBtns d-flex">
      <button
        class="newTask"
        style="border: 0px; cursor: pointer"
        @click="clearAll"
      >
        Clear all
      </button>
      <button
        class="newTask"
        style="border: 0px; cursor: pointer"
        @click="applyFilter"
      >
        Apply
      </button>
    </div>
  </div>
</template>
</template>
<script>
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import config from "../../../../config/settings";
export default {
  data() {
    return {
      companiesList: [],
      tags: [],
      isChecked: {
        isInvestor: false,
        isReferrer: false,
        isFounder: false,
        isTeam: false,
      },
    };
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioAll"]),
    config() {
      return config;
    },
  },
  components: {
    Multiselect,
  },
  mounted() {
    if (this.$parent.filterJson) {
      this.companiesList = this.$parent.filterJson.companiesList
        ? this.$parent.filterJson.companiesList
        : [];
      this.tags = this.$parent.filterJson.tags
        ? this.$parent.filterJson.tags
        : [];
      this.isChecked = this.$parent.filterJson.isChecked
        ? JSON.parse(JSON.stringify(this.$parent.filterJson.isChecked))
        : {
            isInvestor: false,
            isReferrer: false,
            isFounder: false,
            isTeam: false,
          };
    }
  },
  methods: {
    searchName({ name, language }) {
      return `${name}`;
    },
    clearAll() {
      this.companiesList = [];
      this.isChecked = {
        isInvestor: false,
        isReferrer: false,
        isFounder: false,
        isTeam: false,
      };
      this.tags = [];
      this.$parent.filterJson = {};
      this.$parent.isFilterApplied = false;
      this.$parent.customFilterArray = [];
      this.$parent.tabulator.clearFilter(true);
      this.$parent.showFilter = false;
      if (this.$parent.searchQuery && this.$parent.searchQuery.length > 0) {
        this.$parent.tabulator.setFilter([this.$parent.searchFilter]);
      }
    },
    applyFilter() {
      let filterJson = [];
      let self = this;
      let filterCompanies = [];
      if (this.companiesList.length <= 0) filterCompanies = self.portfolioAll;
      else {
        filterCompanies = JSON.parse(JSON.stringify(this.companiesList));
      }

      if (this.tags.length > 0) {
        let filterCompaniesList = [];
        filterCompanies.find((portfolioItem) => {
          if (portfolioItem.tags) {
            let tag = portfolioItem.tags.some((item) =>
              this.tags.includes(item)
            );
            if (tag) filterCompaniesList.push(portfolioItem);
          }
        });
        filterCompanies = filterCompaniesList;
      }
      filterCompanies.map((item) => {
        if (self.isChecked.isFounder)
          filterJson.push({
            field: "foundedCompaniesName",
            type: "like",
            value: item.name,
          });
        if (self.isChecked.isInvestor)
          filterJson.push({
            field: "investedCompaniesName",
            type: "like",
            value: item.name,
          });
        if (!self.isChecked.isFounder && !self.isChecked.isInvestor) {
          filterJson.push({
            field: "foundedCompaniesName",
            type: "like",
            value: item.name,
          });
          filterJson.push({
            field: "investedCompaniesName",
            type: "like",
            value: item.name,
          });
        }
      });
      this.$parent.filterJson = {
        companiesList: this.companiesList,
        isChecked: this.isChecked,
        tags: this.tags,
      };
      if (filterJson.length > 0) this.$parent.customFilterArray = filterJson;
      else {
        filterJson = [
          {
            field: "",
            type: "like",
            value: "",
          },
        ];
      }
      if (this.$parent.searchQuery && this.$parent.searchQuery.length > 0) {
        let tabulatorFilter = [[self.$parent.searchFilter], [filterJson]];
        self.$parent.tabulator.setFilter(tabulatorFilter);
      } else {
        this.$parent.tabulator.setFilter([filterJson]);
      }
      this.$parent.isFilterApplied = true;
      this.$parent.showFilter = false;
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
  },
};
</script>
<style>
</style>